/* ============================================================
   TLC × Fall in Love — Ritual Builder cart logic
   Adds the 3 anchor variants in one click, applies discount code,
   redirects to cart.
   ============================================================ */
(function(){
  'use strict';

  var btn = document.querySelector('[data-fil-add-ritual]');
  if (!btn) return;

  btn.addEventListener('click', function(e){
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var raw  = btn.getAttribute('data-fil-variants') || '';
    var ids  = raw.split(',').map(function(s){ return parseInt(s.trim(), 10); }).filter(function(n){ return n > 0; });
    var code = btn.getAttribute('data-fil-discount') || '';

    if (ids.length === 0) {
      window.location.href = '/collections/fall-in-love';
      return;
    }

    btn.classList.add('is-loading');
    var origText = btn.textContent;
    btn.setAttribute('data-orig', origText);

    var items = ids.map(function(id){ return { id: id, quantity: 1 }; });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      var dest = '/cart';
      if (code) dest = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      window.location.href = dest;
    })
    .catch(function(err){
      btn.classList.remove('is-loading');
      btn.textContent = origText;
      console.warn('[tlc-fil] add ritual failed:', err);
      alert('Could not add the ritual to your bag. Please try the individual products below.');
    });
  });
})();
